import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { EbDashboardLatestClaimsVm } from '../../model/eb-dashboard-latest-claims-vm';
import { LatestClaimStatus } from 'src/app/utility/enum/global-enum';
import { EbEmployeeDashboardDetailsService } from '../../service/eb-employee-dashboard-details/eb-employee-dashboard-details.service';
import { MatDialog } from '@angular/material';
import { DialogEbClaimStatusDetailsComponent } from '../eb-employee-claim-details/dialog-eb-claim-status-details/dialog-eb-claim-status-details.component';

@Component({
  selector: 'app-eb-dashboard-employee-Claim-Status',
  templateUrl: './eb-dashboard-employee-Claim-Status.component.html',
  styleUrls: ['./eb-dashboard-employee-Claim-Status.component.scss']
})
export class EbDashboardEmployeeClaimStatusComponent implements OnInit, OnChanges {
  latestClaimStatus = LatestClaimStatus;

  enrolId : number = null;
  @Input() set setEnrolId(value) {
    if (value) {
      this.enrolId = value;
    }
  }

  @Input() employeeClaimDetails : EbDashboardLatestClaimsVm[];
  constructor(private ebEmployeeDashboardDetailsService: EbEmployeeDashboardDetailsService,
    public dialog: MatDialog
  ) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.employeeClaimDetails.currentValue !== undefined){
      this.employeeClaimDetails = changes.employeeClaimDetails.currentValue;
    }
  }

  toggleClaimDetails(isShowClaimDetails:boolean) {
    this.ebEmployeeDashboardDetailsService.changeSelectedViewMore(isShowClaimDetails);
  }

  openClaimDetailsDialog(claim) {
    const dialogRef = this.dialog.open(
      DialogEbClaimStatusDetailsComponent,
      {
        minWidth: '60%',
        data: { 
          claimEntryId: claim.claimEntryId,
          claimNumber: claim.claimNumber,
          enrolId: this.enrolId
        },
        panelClass: 'custom-dialog-container'
      },
    );

    dialogRef.afterClosed().subscribe((result) => {});
  }

}
